import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";

const RoleProtectedRoute = ({ children, allowedRoles = [] }) => {
  const navigate = useNavigate();
  const role = localStorage.getItem("user_role");
  const token = localStorage.getItem("access_token");

  useEffect(() => {
    // Check if user is logged in
    if (!token) {
      navigate("/");
      return;
    }

    // Check if user has required role
    if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
      toast.error(
        "Access denied. You don't have permission to access this page."
      );
      // Redirect based on user role
      if (role === "Annotator" || role === "Reviewer") {
        navigate("/dashboard");
      } else {
        navigate("/");
      }
      return;
    }
  }, [token, role, allowedRoles, navigate]);

  // If no token or unauthorized role, don't render content
  if (!token || (allowedRoles.length > 0 && !allowedRoles.includes(role))) {
    return null;
  }

  return children;
};

export default RoleProtectedRoute;
